import { useFormikContext } from "formik";
import { useActionModalGetContext } from "context/ActionModalProvider";
import { ACTION_STATUS } from "constants/actions";
import DiagnoseSuggestion from "./DiagnoseSuggestion";
import DiagnosePerformed from "./DiagnosePerformed";

const DiagnoseDetails = ({ viewMode, isNewVersion }) => {
  const { fieldInfo } = useActionModalGetContext();
  const { values } = useFormikContext();

  const isSuggested = values?.status !== ACTION_STATUS.performed;

  return isSuggested ? (
    <DiagnoseSuggestion viewMode={viewMode} isNewVersion={isNewVersion} />
  ) : (
    <DiagnosePerformed fieldInfo={fieldInfo} viewMode={viewMode} isNewVersion={isNewVersion} />
  );
};

export default DiagnoseDetails;
